import { Button, Grid, makeStyles } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import Comment from "../../components/comments/comment";
import config from "../../config";
import { dispatch } from "../../events";
import { types } from "../../events/loader";
import httpUtils from "../../utils/http.utils";

const useStyles = makeStyles((theme) => ({
    messages: {
        height: '300px',
        overflow: 'scroll'
    },
}));


const Comments = () => {
    const classes = useStyles();
    const [comments, setComments] = useState([]);

    const getUrl = (comment) => `${config.BACK_API}/api/${comment.objectType.toLowerCase()}/${comment.objectId}/comment`

    useEffect(() => {
        load({});
    }, []);

    const onDelete = (comment) => {
        setComments(comments.filter(c => c.id !== comment.id))
    }

    const load = async ({ reset = false }) => {
        dispatch(types.SET_LOADER);
        let updatedBefore = undefined;
        if (!reset && comments.length > 0) {
            updatedBefore = comments[comments.length - 1].updatedAt
        }
        const results = (await httpUtils.get(`${config.BACK_API}/api/comment`,
            { updatedBefore, limit: 10, reported: true }
        )).data.results;

        let oldsComments = reset ? [] : comments;
        setComments([...oldsComments, ...results.map(f => ({ ...f, reported: true, comments: { results: [] } }))]);
        dispatch(types.UNSET_LOADER);
    }
    return (
        <>
            <div className={classes.messages}>
                <Grid container>
                    {comments.map((comment) => (
                        <Grid item xs={12} sm={4}>
                            <Comment objectType={comment.objectType} objectId={comment.objectId} comment={comment} requestUrl={getUrl(comment)} onDelete={onDelete} />
                        </Grid>
                    ))}
                </Grid>

                <Button variant="contained" onClick={load}>Load more</Button>
            </div>
        </>
    );
}

export default Comments;